// extracted by mini-css-extract-plugin
module.exports = {"container":"DeltaWarnings_container__308I0","warning":"DeltaWarnings_warning__24dnt","warningIcon":"DeltaWarnings_warningIcon__2xyIK"};